// extracted by mini-css-extract-plugin
module.exports = {"bodyContainer":"layout_bodyContainer__7I42J"};
module.exports.__checksum = "30b340b05e9b"
